import axios from "axios";

function getHeaders() {
  return {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  };
}

export const updateAaraDetails = async (id, addressData) => {
  try {
    const response = await axios.put(
      `${process.env.REACT_APP_BASE_URL}/invoice_price/api/aara-details/${id}/`,
      addressData,
      getHeaders()
    );
    return response.data;
  } catch (error) {
    console.error("Error updating address:", error);
    throw error;
  }
};

export const getInvoices = async (id) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/invoice_price/api/invoices/`,
      getHeaders()
    );

    return response;
  } catch (error) {
    if (error.response) {
      console.error("Backend Error:", error.response.data);
    } else {
      console.error("Network Error:", error);
    }
    throw error;
  }
};

export const submitInvoice = async (data) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/invoice_price/api/invoices/`,
      data,
      getHeaders()
    );
    return response;
  } catch (error) {
    if (error.response) {
      console.error("Backend Error:", error.response.data);
    } else {
      console.error("Network Error:", error);
    }
    throw error;
  }
};

export const sendMail = async (invoiceData) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/invoice_price/api/invoices/${invoiceData.invoiceId}/send-email/`,
      {},
      getHeaders()
    );
    return response;
  } catch (error) {
    if (error.response) {
      console.error("Backend Error:", error.response.data);
    } else {
      console.error("Network Error:", error);
    }
    throw error;
  }
};

export const updateInvoice = async (id, data) => {
  try {
    const response = await axios.put(
      `${process.env.REACT_APP_BASE_URL}/invoice_price/api/invoices/${id}/`,
      data,
      getHeaders()
    );
    return response;
  } catch (error) {
    if (error.response) {
      console.error("Backend Error:", error.response.data);
    } else {
      console.error("Network Error:", error);
    }
    throw error;
  }
};

export const deleteInvoice = async (id) => {
  try {
    const response = await axios.delete(
      `${process.env.REACT_APP_BASE_URL}/invoice_price/api/invoices/${id}/`,
      getHeaders()
    );
    return response;
  } catch (error) {
    if (error.response) {
      console.error("Backend Error:", error.response.data);
    } else {
      console.error("Network Error:", error);
    }
    throw error;
  }
};

export const bulkDeleteInvoices = async (ids) => {
  try {
    const response = await axios.delete(
      `${process.env.REACT_APP_BASE_URL}/invoice_price/api/invoices/bulk-delete/`,
      {
        ...getHeaders(),
        data: { ids }, // Pass IDs in the request body
      }
    );
    return response;
  } catch (error) {
    if (error.response) {
      console.error("Backend Error:", error.response.data);
    } else {
      console.error("Network Error:", error);
    }
    throw error;
  }
};

export const createTremsAndConditions = async (data) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/invoice_price/api/terms-and-conditions/`,
      data,
      {
        ...getHeaders(),
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error creating TremsAndConditions:", error);
    throw error;
  }
};
export const getAllTremsAndConditions = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/invoice_price/api/terms-and-conditions/`,

      {
        ...getHeaders(),
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error fetching TremsAndConditions list:", error);
    throw error;
  }
};
// Retrieve a specific "TremsAndConditions" record by ID
export const getTremsAndConditionsById = async (id) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/invoice_price/api/terms-and-conditions/${id}/`,

      {
        ...getHeaders(),
      }
    );
    return response.data;
  } catch (error) {
    console.error(`Error fetching TremsAndConditions with ID ${id}:`, error);
    throw error;
  }
};

// Update a "TremsAndConditions" record by ID
export const updateTremsAndConditions = async (id, data) => {
  try {
    const response = await axios.patch(
      `${process.env.REACT_APP_BASE_URL}/invoice_price/api/terms-and-conditions/${id}/`,
      data,

      {
        ...getHeaders(),
      }
    );
    return response.data;
  } catch (error) {
    console.error(`Error updating TremsAndConditions with ID ${id}:`, error);
    throw error;
  }
};

// Delete a "TremsAndConditions" record by ID
export const deleteTremsAndConditions = async (id) => {
  try {
    await axios.delete(
      `${process.env.REACT_APP_BASE_URL}/invoice_price/api/terms-and-conditions/${id}/`,

      {
        ...getHeaders(),
      }
    );
  } catch (error) {
    console.error(`Error deleting TremsAndConditions with ID ${id}:`, error);
    throw error;
  }
};

export const getAddress = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/invoice_price/api/aara-details`,
      getHeaders()
    );
    return response;
  } catch (error) {
    if (error.response) {
      console.error("Backend Error:", error.response.data);
    } else {
      console.error("Network Error:", error);
    }
    throw error;
  }
};
